import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';

const ConsultationSection = () => {
  return (
    <section
      id="consultation"
      className="py-16 sm:py-20 lg:py-24 relative overflow-hidden bg-slate-950"
      data-testid="consultation-section"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-slate-950 to-emerald-900/20" aria-hidden="true"></div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600/15 rounded-full blur-3xl" aria-hidden="true"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-sm rounded-3xl p-8 sm:p-12 border border-slate-700/60 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Book Your <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Free Consultation</span>
          </h2>
          <p className="text-base sm:text-lg text-slate-300 mb-8 max-w-2xl mx-auto leading-relaxed">
            Speak with our team and understand which program best suits your health goals.
          </p>
          <Link
            to="/book-consultation?from=consultation-section"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-500 hover:to-cyan-500 text-white px-8 py-4 rounded-full font-bold text-base sm:text-lg transition-all shadow-lg shadow-blue-500/25 hover:scale-105"
            data-testid="consultation-cta-btn"
          >
            Book My Free Consultation
            <ArrowRight className="w-5 h-5" aria-hidden="true" />
          </Link>
          <p className="mt-6 inline-flex items-center gap-1.5 text-slate-400 text-sm">
            <Lock className="w-4 h-4 text-emerald-400" aria-hidden="true" />
            Your information remains completely private and confidential.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConsultationSection;
